import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import { DataGridProvider } from "@vega-core/components/DataGrid/DataGridProvider";
import { OutdatedBrowserModal } from "@vega-core/components/OutdatedBrowserModal/OutdatedBrowserModal";
import { ToastContainer } from "@vega-core/components/Toast/Toast";
import { CoInvestNotificationsStreamRunner } from "@vega-modules/scenes/CoInvestments/components/CoInvestNotificationsStreamRunner/CoInvestNotificationsStreamRunner";
import { ProvidersWrapper } from "@vega-modules/scenes/Root/ProvidersWrapper";

import { LpCoInvestLayoutContextProvider } from "./components/Layout/LpCoInvestLayoutContextProvider";
import { Root } from "./scenes/Root/Root";
import { lpCoInvestRouteObjects } from "./scenes/Root/Routes";

import "@vega-assets/css/index.css";
import "inter-ui/inter-variable.css";
import "inter-ui/inter.css";

export function App() {
  return (
    <DataGridProvider>
      <ProvidersWrapper
        outletWrapper={(outlet) => (
          <>
            <LpCoInvestLayoutContextProvider>
              <Root>{outlet}</Root>
              <CoInvestNotificationsStreamRunner />
              <div id="sidebar-modal-root" />
              <ToastContainer />
              <OutdatedBrowserModal />
            </LpCoInvestLayoutContextProvider>
            <ReactQueryDevtools
              buttonPosition="bottom-left"
              initialIsOpen={false}
            />
          </>
        )}
        routes={lpCoInvestRouteObjects}
      />
    </DataGridProvider>
  );
}
